import { useEffect, useState } from "react";
import UserTable from "../components/UserTable";
import SearchBar from "../components/SearchBar";

function Dashboard() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("name");

  // 🔥 separate sort states
  const [nameOrder, setNameOrder] = useState("asc");
  const [companyOrder, setCompanyOrder] = useState("asc");

  // API call
  useEffect(() => {
    fetch("https://jsonplaceholder.typicode.com/users")
      .then(res => res.json())
      .then(data => setUsers(data));
  }, []);

  // Search
  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase())
  );

  // 🔥 FIXED SORT LOGIC
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    let valueA =
      sortField === "company" ? a.company.name : a.name;

    let valueB =
      sortField === "company" ? b.company.name : b.name;

    const order =
      sortField === "company" ? companyOrder : nameOrder;

    return order === "asc"
      ? valueA.localeCompare(valueB)
      : valueB.localeCompare(valueA);
  });

  return (
    <div className="container">
      <h2>User Directory Dashboard</h2>

      <div className="search-container">
        <SearchBar setSearch={setSearch} />

        <div className="button-group">
          
          {/* 🔥 Sort by Name */}
          <button
            className={sortField === "name" ? "active" : ""}
            onClick={() => {
              setSortField("name");
              setNameOrder(nameOrder === "asc" ? "desc" : "asc");
            }}
          >
            Sort Name ({nameOrder})
          </button>

          {/* 🔥 Sort by Company */}
          <button
            className={sortField === "company" ? "active" : ""}
            onClick={() => {
              setSortField("company");
              setCompanyOrder(companyOrder === "asc" ? "desc" : "asc");
            }}
          >
            Sort Company ({companyOrder})
          </button>

        </div>
      </div>

      <UserTable users={sortedUsers} />
    </div>
  );
}

export default Dashboard;